var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarVotingBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32829 9H4C2.89543 9 2 9.89543 2 11V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9H18.672L15.672 12H17.0003C17.5526 12 18.0003 12.4477 18.0003 13C18.0003 13.5523 17.5526 14 17.0003 14H7.00033C6.44804 14 6.00033 13.5523 6.00033 13C6.00033 12.4477 6.44804 12 7.00033 12H8.32829L5.32829 9Z",
    fill: "#077CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9144 1.91391L18.086 5.08548C18.867 5.86653 18.867 7.13286 18.086 7.91391L13.4144 12.5855C12.6334 13.3665 11.367 13.3665 10.586 12.5855L7.4144 9.41391C6.63335 8.63286 6.63335 7.36653 7.4144 6.58548L12.086 1.91391C12.867 1.13286 14.1334 1.13286 14.9144 1.91391ZM11.2932 11.2923L8.70745 8.70648C8.31693 8.31595 8.31693 7.68279 8.70746 7.29227L12.7932 3.20648C13.1838 2.81596 13.8169 2.81596 14.2075 3.20648L16.7932 5.79227C17.1838 6.18279 17.1838 6.81596 16.7932 7.20648L12.7075 11.2923C12.3169 11.6828 11.6838 11.6828 11.2932 11.2923Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarVotingBlue);
export default __webpack_public_path__ + "static/media/sidebar_voting_blue.d74383efb935d8186fb2faaf6be22139.svg";
export { ForwardRef as ReactComponent };